import { Component, OnInit, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { DynamicSQLService } from '../../../../services/dynamic-sql.service';
import { ColDef, GridApi, GridOptions, SideBarDef, Column } from 'ag-grid-enterprise';
import "ag-grid-enterprise";
import { setAgGridLicense } from '../../../../config/ag-grid-license';
import 'chosen-js';
import { WWSelectComponent } from './qb-intercompany-select';
import { PfsService } from 'src/app/services/pfs.service';

@Component({
  selector: 'app-qbintercompany-grid',
  templateUrl: './qb-intercompany.component.html',
  styleUrls: ['./qb-intercompany.component.css']
})
export class QBIntercompanyComponent implements OnInit {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  @ViewChild('wwSelect') sel!: WWSelectComponent;

    token!: string;
  private gridApi!: GridApi;
  columnDefs: any[] = [];
  disableFilters:any = null;
  dropdownOptionsMap: {
    [key: string]: {
      ref_value: string;
      insert_value: string;
      insert_col?: string;
    }[]
  } = {};
  error_msg = "";
  filters = {
    employee:"",
    client: "",
    entityA: "",
    entityAAccount: "",
    entityB: "",
    entityBAccount: ""
  };
  gridOptions: GridOptions<any> = {
    columnDefs: this.columnDefs,
    onGridReady: (params) => this.onGridReady(params),
  };
  listClients: any[] = [];
  listEntities: any[] = [];
  listAccountsA: any[] = [];
  listAccountsB: any[] = [];
  params: any;
  rowData: any[] = [];
  rowSelection: any = "single";
  saveMode = "add";
  searchText!: string;
  tableColumns: string[] = [];
  tableName = "qb_intercompany_mapping";
  userID: any = sessionStorage.getItem('wOSAuthUser') || "";

  constructor(
    private dynamicSQLService: DynamicSQLService,
    private pfsService: PfsService
  ) {
  }

  ngOnInit(): void {
    console.log("Angular Intialized")
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.buildGrid();       // build the grid
    this.loadAdminData(this.tableName); // get existing data
    this.getClientFilter(); // populate the add client filter
  }

  buildGrid(): any {
    const baseColDef = {
      editable: false,
      sortable: true,
      filter: false,
      resizable: true,
      width: 200,
      suppressHeaderMenuButton: true,
      suppressSizeToFit: true
    }

    this.columnDefs = [
      { ...baseColDef, field: 'client_id_s_name', headerName: "Client", width: 125 },
      { ...baseColDef, field: 'a_entity_EntityID', headerName: "Entity A", width: 125 },
      { ...baseColDef, field: 'a_account_id_account_name', headerName: "Entity A Account", width: 350 },
      { ...baseColDef, field: 'b_entity_EntityID', headerName: "Entity B", width: 125 },
      { ...baseColDef, field: 'b_account_id_account_name', suppressSizeToFit: false, headerName: "Entity B Account" },
      {
        ...baseColDef,
        cellRenderer: (params: any) => {
          const div = document.createElement('div');
          div.className = 'pointer';
          div.innerHTML = `<i class="fas fa-fw fa-trash c_bonedk" title="Delete Row ${params.data.id}" id="del_${params.data.id}"></i>`;
          div.addEventListener('click', (e: any) => {
            const key = e.srcElement.id.split('_')[1];
            this.deleteClick(this.tableName, key, e);
          })
          return div;
        },
        cellRendererParams: { table_name: this.tableName },
        cellEditorParams: {
          values: [],
        },
        field: `id`,
        headerName: "",
        width: 125,
        cellClass: 'text-center',
        pinned: 'right',
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        resizable: false
      }
    ];

    // crete a new column object to add to the spec
    const actionCol: { [key: string]: string | number | null } = {
      "display_order": 99,
      "display_name": " ",
      "data_type": "ACTIONS",
    };
  }

  loadAdminData(table: string): void {
    this.dynamicSQLService.getTableData(table, this.token).subscribe(
      (data) => {
        if (data.length > 0) {
          this.tableColumns = Object.keys(data[0]);
          this.tableColumns = this.tableColumns.filter(
            (column) =>
              !this.columnDefs.some(
                (colDef) =>
                  colDef.field === column &&
                  colDef.context?.ref_asname
              )
          );
        } else {
          console.warn('No data available to determine table columns.');
          this.tableColumns = [];
        }
        this.rowData = data.map((item: { id: any }) => ({
          ...item,
          id: item.id,

        }));

        // set the row data
        this.gridApi.setGridOption('rowData', this.rowData);

        // slight delay, then size columns
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 750)
        
      },
      (error) => console.error(`Error fetching data for ${table}:`, error)
    );
  }

  deleteClick(table: string,rowid:any,event: any) {
    try {
      // stop the row click event from happening, too
      this.saveMode = "delete";
      event.stopPropagation();

        // issue the delete call
        this.dynamicSQLService.deleteItem(table, rowid, this.token).subscribe(
          (response) => {
            this.loadAdminData(this.tableName);
            this.resetFilters();
        },
        (error) => {
          console.error(`Error updating row ${rowid}`, error);
        }
      );
    } catch (ex) {
      console.error("Delete Error >> ", ex)
    }
  }

  onSelectionChanged(event: any) {
    if (event.source != "apiSelectAll") {
      // set save mode to edit and get reference to the current row data
      this.saveMode = "edit";
      const selectedRows = this.gridApi.getSelectedRows();
      const rowdata: any = selectedRows[0];
      
      // disable the filters and set the variables to pass to getExistingRecord()
      this.getExistingRecord(rowdata);
    } 
  }

  saveRow(): void {
    // simple validation 
    if (this.filters.client == '') {
      this.error_msg = 'Client is required';
      $('#flt_client').trigger('focus');
      setTimeout(() => { this.error_msg = '' },3000)
      return;
    }
    if (this.filters.entityA == '') {
      this.error_msg = 'Entity A is required';
      setTimeout(() => { this.error_msg = '' }, 3000)
      return;
    }
    if (this.filters.entityAAccount == '') {
      this.error_msg = 'Entity A Account is required';
      setTimeout(() => { this.error_msg = '' }, 3000)
      return;
    }
    if (this.filters.entityB == '') {
      this.error_msg = 'Entity B is required';
      setTimeout(() => { this.error_msg = '' }, 3000)
      return;
    }
    if (this.filters.entityBAccount == '') {
      this.error_msg = 'Entity B Account is required';
      setTimeout(() => { this.error_msg = '' },3000)
      return;
    }

    const saverow = {
      id: null,
        a_entity: this.filters.entityA,
          a_account_id: this.filters.entityAAccount,
            b_entity: this.filters.entityB,
              b_account_id: this.filters.entityBAccount,
                client_id: this.filters.client
    }

    const kvps = this.dataToKVP(saverow);
    this.dynamicSQLService.insertItem(this.userID, this.tableName,  kvps, this.token).subscribe(
      (data) => {
        console.log(data);
        if (data.message == 'Item added successfully') {
          this.loadAdminData(this.tableName);
          
          // clear the entry fields and set focus on the first entity
          this.resetFilters();


        } else {
          console.warn('insert failed');
          //this.tableColumns = [];
        }
      },
      (error) => console.error(`Error fetching data for entities:`, error)
    );
    // set the focus on the first required field
    $('#flt_entitya').trigger('focus');

  }

  resetFilters(): void {
    console.log("resetFilters()", this.saveMode);

    // always clear these
    this.filters.entityA = "";
    this.filters.entityAAccount = "";
    this.filters.entityB = "";
    this.filters.entityBAccount = "";

    // if you were editing or deleting 
    if (this.saveMode == "edit" || this.saveMode == "delete") {
      this.gridApi.deselectAll();
      this.filters.client = "";
      this.saveMode = "add";
    } else {
      console.log("Reset to Add Mode > " + this.filters.client);
    }
  }
  
  searchChange(term: string): void {
    this.gridApi.setGridOption("quickFilterText", term);
  }

  getExistingRecord(obj: any): void {
    this.disableFilters = true;

    this.pfsService.getQBInterCompanyRecord(obj.client_id, obj.a_entity, obj.b_entity).then(
      (data) => {
        // clear existing entries
        this.listEntities.length = 0;
        this.listAccountsA.length = 0;
        this.listAccountsB.length = 0;
        
        // repopulate with the data from the call
        this.listEntities = data.entities;
        this.listAccountsA = data.accounts_a;
        this.listAccountsB = data.accounts_b;
        
        setTimeout(() => {
          this.filters.client = obj.client_id;
          this.filters.entityA = obj.a_entity;
          this.filters.entityB = obj.b_entity;
          this.filters.entityAAccount = obj.a_account_id;
          this.filters.entityBAccount = obj.b_account_id;
          this.disableFilters = false;
        }, 3000);
      },
      (error) => console.error(`Error fetching existing intercompany record:`, error)
    );
  }

  getClientFilter(): void {
    this.dynamicSQLService.getDropdownOptionsForColumn(this.tableName, "pp_clients", "s_name", this.token).subscribe(

      (data) => {
        if (data.length > 0) {
          this.listClients = data;
        } else {
          console.warn('No data available - clients filter');
        }
      },
      (error) => console.error(`Error fetching data for pp_clients:`, error)
    );
  }

  getEntityFilter(): void {
    const cli = "client_id=" + this.filters.client;
    this.dynamicSQLService.getDropdownOptionsForColumn(this.tableName, "entities", "EntityID", this.token).subscribe(
      (data) => {
        if (data.length > 0) {
          console.log("from getEntityFilter()", data)
          this.listEntities = data;
        }
        else { 
          this.listEntities = [];
          console.warn('No data available - entities filter');
        }
      },
      (error) => console.error(`Error fetching data for entities:`, error)
    );
  }

  getAccountFilter(type: string | null): void {
    const filtertype = (type == 'a') ? this.filters.entityA : this.filters.entityB;
    const entity = "entity_id=" + filtertype;
    
    this.dynamicSQLService.getDropdownOptionsForColumn(this.tableName, "qb_account_list_normalized", "account_name", this.token).subscribe(
      (data) => {
        if (data.length > 0) {
          // populate account list
          if (type == 'a') 
            this.listAccountsA = data;
           else 
            this.listAccountsB = data;
        } else {
          // clear the existing entries
          this.listAccountsA = [];
          this.listAccountsB = [];
          console.warn('No account data available - Account');
        }
      },
      (error) => console.error(`Error fetching data for account:`, error)
    );
  }

  dataToKVP(row: any): string {
    const keyValPairs: string[] = [];
    const seenKeys = new Set<string>();
    Object.keys(row).forEach((key) => {

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const value = row[key];
      if (
        key !== 'isBlank' &&
        key !== 'isDirty' &&
        !this.dropdownOptionsMap[key] &&
        !seenKeys.has(key) &&
        this.tableColumns.includes(key)
      ) {
        let formattedValue;
        if (key.includes('date') || key.includes('time')) {
          if (value) {
            const date = new Date(value);
            if (!isNaN(date.getTime())) {
              formattedValue = `'${date.toISOString().slice(0, 19).replace('T', ' ')}'`;
            } else {
              console.warn(`Invalid date value for key ${key}:`, value);
              formattedValue = 'null';
            }
          } else {
            formattedValue = 'null';
          }
        }
        else if (typeof value === 'string') {
          formattedValue = `'${value.replace(/'/g, "''")}'`;
        }
        else if (value === null) {
          formattedValue = 'null';
        }
        else {
          formattedValue = value;
        }
        keyValPairs.push(`${key}=${formattedValue}`);
        seenKeys.add(key);
      }
    });
    return keyValPairs.join(', ');
  }
}
